import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import ClickOutside from 'vue-click-outside'

import { ConfirmModal } from '@src/elements/modal/confirm-modal'
import { AVAILABLE_LOCALES, NotificationTypes } from '@src/util/constants'
import SessionManager from '@src/lib/session_manager'
import { MenuButton } from '@src/elements/button/button'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'
import { Icon } from '@src/elements/icon/icon'
import Cookies from '@src/lib/cookies'
import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'

@Component
export class ProfileOptions extends Vue {

  logoutConfirmVisible: boolean = false

  constructor () {
    super()
  }

  showLogoutConfirm () {
    this.logoutConfirmVisible = !this.logoutConfirmVisible
  }

  goToAccount () {
    if (SessionManager.Instance.isManager()) {
      this.$router.push('/trainers/platform/account')
    } else {
      this.$router.push(`/members/${this.$route.params.id}/account`)
    }
  }

  logout (confirm: boolean) {
    if (confirm === true) {
      SessionManager.Instance.logout()
      this.$store.dispatch('logout')
      this.$router.push('/')
    }
    this.logoutConfirmVisible = false
  }

  render (h: CreateElement) {
    return <div class='account-settings'>
      <MenuButton>
        <div slot='button' class='language-label'>
          <div class='switch-label'>
            <div class='vertical-separator' />
            <Subtitle2>{this.$t('PAGE.MEMBERS.ACCOUNT.ACCOUNT_SETTINGS')}</Subtitle2>
          </div>
        </div>

        <Popover>
          <OptionGroup>
            <div onClick={this.goToAccount} class='profile-option' ref='accountBtn'><Subtitle1>{this.$t('PAGE.MEMBERS.ACCOUNT.ACCOUNT_SETTINGS')}</Subtitle1></div>
            <div onClick={this.showLogoutConfirm} class='profile-option' ref='logoutBtn'><Subtitle1>{this.$t('PAGE.LOGOUT.SUBMIT_BUTTON')}</Subtitle1></div>
          </OptionGroup>
        </Popover>
      </MenuButton>

      <ConfirmModal show={this.logoutConfirmVisible}
                    closeCallback={this.logout}
                    message={this.$t('PAGE.LOGOUT.CONFIRM')}
                    type={NotificationTypes.CONFIRM} />
    </div>
  }
}

@Component({
  directives: {
    ClickOutside
  },
  computed: {
    locale () {
      return this.$store.state.i18n.locale
    }
  }
})
export class MobileProfileOptions extends ProfileOptions {

  protected apiClient: ApiClient = new ApiClient()
  private languagesVisible: boolean = false

  constructor () {
    super()
    let storedLocale = Cookies.get('Locale')
    if (storedLocale) {
      this.$store.dispatch('switchLanguage', storedLocale)
    } else {
      Cookies.set('Locale', 'en-gb', { expires: '5Y' })
    }
  }

  changeLanguage (locale) {
    this.showHideLanguages()
    if (this.$store.state.user) {
      return this.apiClient.put(SessionManager.Instance.isManager() ? API.TRAINERS_API.PROFILE : API.MEMBERS_API.PROFILE, { profile: ({ locale: locale }) })
        .then(() => {
          this.$store.dispatch('switchLanguage', locale)
          Cookies.set('Locale', locale, { expires: '5Y' })
        })
        .catch((error) => console.log('error updating language in profile settings', error))
    } else {
      this.$store.dispatch('switchLanguage', locale)
      Cookies.set('Locale', locale, { expires: '5Y' })
    }
  }

  showHideLanguages () {
    this.languagesVisible = !this.languagesVisible
  }

  render (h: CreateElement) {
    const languages = AVAILABLE_LOCALES.map(locale => {
      return <div onClick={() => this.changeLanguage(locale)} class='locale-row' ref={locale}>
        <Icon name={`country-flags/${locale}`} />
        <Subtitle1>{this.$t(`LANGUAGES.${locale}`)}</Subtitle1>
      </div>
    })

    return <div class='mobile-account-settings'>
      <MenuButton>
        <Popover>
          <OptionGroup>
            <div onClick={this.goToAccount} class='profile-option' ref='accountBtn'><Subtitle1>{this.$t('PAGE.MEMBERS.ACCOUNT.ACCOUNT_SETTINGS')}</Subtitle1></div>
            <div onClick={this.showHideLanguages} class='profile-option' ref='switchLanguageBtn'><Subtitle1>{this.$t('SWITCH_LANGUAGE')}</Subtitle1></div>
            <div onClick={this.showLogoutConfirm} class='profile-option' ref='logoutBtn'><Subtitle1>{this.$t('PAGE.LOGOUT.SUBMIT_BUTTON')}</Subtitle1></div>
          </OptionGroup>
        </Popover>
      </MenuButton>

      <ConfirmModal show={this.logoutConfirmVisible}
                    closeCallback={this.logout}
                    message={this.$t('PAGE.LOGOUT.CONFIRM')}
                    type={NotificationTypes.CONFIRM} />

      {this.languagesVisible ?
        <Popover class='language-options' v-click-outside={this.showHideLanguages}>
          <OptionGroup>
            {languages}
          </OptionGroup>
        </Popover> : null}
    </div>
  }
}
